import { getData, getDataV3, postData } from "@/lib/request";

export const getListPageFB = (params) =>
  getData("web/list_page/getListPageFB", params);
export const getListFormFB = (params) =>
  getData("web/list_form/getListFormFB", params);
export const updateListPageFB = (params) =>
  postData("web/list_page/updateListPageFB", params);
export const updatePageFB = (params) =>
  postData("web/list_page/updatePageFB", params);
export const updateStatusPageFB = (params) =>
  postData("web/list_page/updateStatusPageFB", params);
